import { AppRouteProps } from "@bsm/component";
import React from "react";

const TeacherDetailsAboutContainer = React.lazy(() => import('./containers/TeacherDetailsAboutContainer'));

export const TeacherDetailsAboutRoutes: Array<AppRouteProps> = [
    {
        path: "about",
        title: '{{TeacherNameDetailsTab}}',
        element: <TeacherDetailsAboutContainer />
    }
]